<template>
  <div class="head-container">
    <div :class="[
      'header-box',
      $route.path !== '/home' ? 'header-box-active' : '',
      'header-fixed',
      isFixed ? 'header-box-active' : '',
    ]">
      <div class="container">
        <div class="header-left" @click="handleJump">
          <i class="icon icon-logo"></i>
        </div>
        <div class="header-right">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" active-text-color="#1772f7"
            text-color="#373e4f" @select="handleSelect" ref="menu">
            <el-menu-item index="0">首页</el-menu-item>
            <!-- <el-menu-item class="link-babe" index="-1"
              >链接宝贝
              <img class="icon_new2" src="~@/assets/icons/icon-new.gif" />
            </el-menu-item>
            <el-menu-item index="5" class="andu"
              >暗度
              <img class="icon_new" src="~@/assets/icons/icon-new.gif" />
            </el-menu-item> -->
            <el-menu-item index="1">使用教程</el-menu-item>
            <el-menu-item index="2">知识文章</el-menu-item>
            <!-- <el-menu-item index="3">客户评价</el-menu-item> -->
            <el-menu-item index="7">关于我们</el-menu-item>
            <!-- 
            <el-menu-item></el-menu-item>
            <el-menu-item></el-menu-item>
            <el-menu-item></el-menu-item>
            <el-menu-item></el-menu-item>
            <el-menu-item></el-menu-item>
            -->
            <!-- <el-menu-item index="6">工具箱</el-menu-item> -->
          </el-menu>
          <div class="header-tap-btn">
            <div class="header-tap-btn-box">
              <el-button class="recharge-btn btn" @click="toRecharge" v-if="isLogin">充值
                <img class="icon-gift" src="@/assets/activity/礼标签.png" />
              </el-button>
              <span class="inviter-btn16 btn mr10" @click="tapInvite" v-if="isLogin">
                <img src="~@/assets/icons/bnt-invite.gif" />

              </span>
              <!--
            <el-button class="inviter-btn btn" @click="tapInvite" v-if="isLogin"
              >邀请有礼</el-button
            >
            -->
              <el-button class="login-btn btn" v-if="!isLogin" @click="tapLogin">登录</el-button>
              <div v-else class="user-info" @dblclick="$router.push('/user-info')">
                <el-dropdown @command="handleCommand" placement="bottom-start">
                  <span class="el-dropdown-link">
                    <img class="icon-user-head" :src="userPicture" alt="" v-if="userPicture" />
                    <img class="icon-user-head" src="../../assets/home/user-head.png" alt="" v-else />
                    <div class="my-user">
                      <span>我的账户</span>
                      <span class="time" v-if="memberExpireDate">{{ memberExpireDate }}会员到期</span>
                    </div>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="/user-info">
                      <i class="icon icon-user-info"></i>
                      <span>个人信息</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="/recharge-record">
                      <i class="icon icon-recharge-record"></i>
                      <span>充值记录</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="/use-record">
                      <i class="icon icon-use-record"></i>
                      <span>消耗记录</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="/query-record">
                      <i class="icon icon-query"></i>
                      <span>查询记录</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="/invite-record">
                      <i class="icon icon-invite-record"></i>
                      <span>邀请记录</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="quit">
                      <i class="icon icon-close"></i>
                      <span>退出登录</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login :loginDV="loginDV" @closeLoginDV="closeLoginDV" @isLogin="handleLogin" @setUserInfo="setUserInfo" />
  </div>
</template>

<script>
import { getItem, removeItem } from "@/utils/storage.js";
import { isLogin } from "@/api/home.js";
import Login from "./components/login.vue";
import qs from 'qs'
import { mapState } from "vuex";
// import { statUser } from '@/api/home.js'
export default {
  name: "Header",
  components: {
    Login,
  },
  props: {},
  data() {
    return {
      isFixed: false,
      activeIndex: 0,
      isLogin: false,
      loginDV: false,
      userInfo: {},
      userPicture: "",
      memberExpireDate: "",
    };
  },
  computed: { ...mapState(["loginVuex", "isFromFriend"]) },
  watch: {
    loginVuex(newVal) {
      this.loginDV = newVal;
    },
    $route: {
      handler() {
        if (this.$route.path == "/home") {
          this.activeIndex = "0";
        } else if (
          this.$route.path == "/course-page" ||
          this.$route.path == "/course"
        ) {
          this.activeIndex = "1";
        } else if (
          this.$route.path == "/artcle-page" ||
          this.$route.path == "/artcle"
        ) {
          this.activeIndex = "2";
        } else if (this.$route.path == "/client") {
          this.activeIndex = "3";
        } else if (this.$route.path == "/toolCabinet") {
          this.activeIndex = "6";
        } else if (this.$route.path == "/regard") {
          this.activeIndex = "7";
        } else {
          this.activeIndex = "4";
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.pageScroll);
    this.$eventBus.$on("openLoginDV", () => {
      this.tapLogin();
    });
    const { clientId, profileId, country, zbuc } = qs.parse(
      window.location.search.slice(1)
    );
    if (clientId === "kxx21010009" && zbuc) {
      if (!getItem("userInfo")) {
        this.loginDV = true;
      } else {
        this.$eventBus.$emit("onSearch", { profileId, country });
      }
      return;
    }
    if (this.$route.params.logo || zbuc) {
      this.loginDV = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.pageScroll);
  },
  methods: {
    havelogged() {
      isLogin().then((res) => {
        if (res.data) {
          let userInfo = getItem("userInfo");
          if (userInfo) {
            this.userInfo = userInfo;
            this.isLogin = true;
            this.userPicture = userInfo.headImageUrl;
            this.memberExpireDate =
              +new Date(userInfo.memberExpireDate) - +new Date() <=
                1000 * 60 * 60 * 24 * 15
                ? userInfo.memberExpireDate
                : "";
          }
        }
      });
    },
    pageScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > 80 ? true : false;
    },
    handleSelect(index) {
      // if (index === '6') {
      //   // this.$message.warning('即将上线，敬请期待~')
      //    this.$router.push('/toolCabinet')
      //   // if (!getItem('userInfo')) return
      //   // statUser({ type: 'tool' })
      //   return
      // }
      let path;
      switch (index) {
        case "0":
          path = "/home";
          break;
        case "1":
          path = "/course-page";
          break;
        case "2":
          path = "/artcle-page";
          break;
        case "3":
          path = "/client";
          break;
        case "6":
          path = "/toolCabinet";
          break;
        case "7":
          path = "/regard";
          break;
        default:
          // window.location.href = "https://www.lianjiebaobei.com/";
          // this.$message.closeAll()
          // this.$message.success('敬请期待！')
          break;
      }
      // if (index == 3) {
      //   if (this.$route.path == '/home') {
      //     this.$refs['menu'].activeIndex = '0'
      //   } else if (this.$route.path == '/course-page' || this.$route.path == '/course') {
      //     this.$refs['menu'].activeIndex = '1'
      //   } else if (this.$route.path == '/artcle-page' || this.$route.path == '/artcle') {
      //     this.$refs['menu'].activeIndex = '2'
      //   } else if (this.$route.path == '/client') {
      //     this.$refs['menu'].activeIndex = '3'
      //   }
      // } else {
      //   this.$router.push(path)
      // }
      if (path) {
      this.$router.push(path);
      }
    },
    async handleCommand(val) {
      if (val === "quit") {
        // try {
        //   console.log(123);
        // } catch (err) {
        //   console.log(err);
        // }
        removeItem("userInfo");
        var date = new Date();
        date.setTime(date.getTime() - 10000);
        document.cookie = "fst=a; expires=" + date.toGMTString();
        if (this.$route.path !== "/home") {
          this.$router.replace("/home");
        } else {
          location.reload();
        }
      } else {
        this.$router.push(val);
      }
    },
    toRecharge() {
      this.$router.push("/recharge");
    },
    tapInvite() {
      this.$router.push("/invite-activity");
    },
    tapLogin() {
      this.loginDV = true;
    },
    closeLoginDV() {
      this.loginDV = false;
    },
    handleLogin() {
      this.loginDV = false;
      this.userInfo = getItem("userInfo") || {};
      this.userPicture = this.userInfo.headImageUrl;
      this.memberExpireDate =
        +new Date(this.userInfo.memberExpireDate) - +new Date() <=
          1000 * 60 * 60 * 24 * 15
          ? this.userInfo.memberExpireDate
          : "";
      this.isLogin = true;
    },
    setUserInfo() {
      this.userInfo = getItem("userInfo") || {};
      this.userPicture = this.userInfo.headImageUrl;
      this.memberExpireDate =
        +new Date(this.userInfo.memberExpireDate) - +new Date() <=
          1000 * 60 * 60 * 24 * 15
          ? this.userInfo.memberExpireDate
          : "";
      this.isLogin = true;
    },
    handleJump() {
      this.$router.push("/home");
    },
  },
};
</script>

<style scoped lang="scss">
.link-babe {
  position: relative;
}

.andu {
  position: relative;
}

.el-menu-demo {
  .el-menu-item {
    position: relative;
    .new-icon {
      position: absolute;
      top: -5px;
      right: -25px;
      width: 46px;
      z-index: 1;
    }
  }
}

.head-container {
  .header-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 9;
    /* width: 100vw; */
    padding-right: 1vw;
  }

  .header-box {
    display: flex;
    justify-content: center;

    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1360px;
      height: 80px;
    }

    .header-left {
      display: flex;
      align-items: center;
      cursor: pointer;

      .icon-logo {
        font-size: 26px;
      }
    }

    .header-right {
      display: flex;

      .el-menu {
        border-bottom: 0;
        margin-right: 40px;

        .is-active {
          border-bottom: 3px solid #3c7cff !important;
          color: #3c7cff !important;
          border-radius: 1px;
        }

        .el-menu-item {
          font-size: 20px;
          margin-right: 4px;
        }
      }

      .header-tap-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        min-width: 320px;

        .header-tap-btn-box {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 32px;
          color: #fff;
          border-radius: 16px;
        }

        .recharge-btn {
          position: relative;
          margin-right: 10px;
          background: linear-gradient(90deg, #ff5f48, #ffa949);
          padding: 0;
          border: 0px solid #dcdfe6;

          .icon-gift {
            position: absolute;
            right: -20px;
            ;
            top: -20px;
            width: 46px;
          }
        }

        .inviter-btn1 {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          cursor: pointer;
          text-align: center;
          border: none;
          background-size: 300% 100%;
          border-radius: 50px;
          margin-right: 10px;
          background-image: linear-gradient(to right,
              #6253e1,
              #852d91,
              #a3a1ff,
              #f24645);

          &:hover {
            background-position: 100% 0;
            transition: all 0.4s ease-in-out;
          }

          animation: sun 2.6s infinite;

          @keyframes sun {
            100% {
              background-position: 100% 0;
            }
          }
        }

        .inviter-btn {
          margin-right: 10px;
          border: 1px solid #fc654e;
          color: #ff6447;
          /* background-image: linear-gradient(to right, 
          #ffbfb8, #ffbfb8, #ffbfb8, #ffe2c6, 
          #ffbfb8, #ffbfb8, #ffbfb8); */
          background-color: #ffbfb8;
          background-image: linear-gradient(90deg,
              #ffbfb8 20%,
              #ffe2c6 40%,
              #ffbfb8 53%);
          padding: 0;
          position: relative;
          background-size: 300% 100%;
          animation: sun 0.7s infinite;
          background-position: 60% 0;

          @keyframes sun {
            0% {
              background-position: 60% 0;
            }

            100% {
              background-position: -10% 0;
            }
          }
        }

        .login-btn {
          color: #3c7cff;
          font-weight: 400;
          border: 1px solid #3c7cff;
          padding: 0;
        }

        .user-info {
          .el-dropdown-link {
            display: flex;
            align-items: center;
          }

          .icon-user-head {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 4px;
          }

          ::v-deep.el-dropdown-menu__item:focus,
          .el-dropdown-menu__item:not(.is-disabled):hover {
            color: #3c7cff !important;
          }
        }

        .my-user {
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 16px;
          font-weight: 400;
          color: #3c7cff;

          .time {
            color: #ff0a00;
            font-size: 14px;
          }
        }
      }
    }
  }

  .header-box-active {
    box-shadow: 0px 4px 8px 0px rgba(172, 189, 213, 0.4);
  }

  .el-dropdown-menu {
    margin-left: -5px !important;

    .icon {
      display: inline-block;
      font-size: 20px;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}

.icon_new {
  position: absolute;
  top: 0;
  right: -5px;
}

.icon_new2 {
  position: absolute;
  top: 0;
  right: -5px;
}

.header-new-drop li {
  color: red !important;
}
</style>
